const MODERN_PLANNING_STORES = new Set([
  'vapostore montpellier',
  'vapostore perpignan doumer',
  'vapostore perpignan polygone',
]);

export function normalizeStoreName(name) {
  return String(name || '').trim().replace(/\s+/g, ' ').toLowerCase();
}

export function isModernPlanningStore(store) {
  return MODERN_PLANNING_STORES.has(normalizeStoreName(store?.name));
}
